import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  desktopContainer: {
    display: {
      xs: 'none',
      md: 'flex',
    },
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: {
      xs: '16px',
      md: '20px',
      lg: '24px',
    },
    boxShadow: 3,
    borderRadius: '16px',
    padding: '1.5rem',
  },
  mobileContainer: {
    display: {
      xs: 'flex',
      md: 'none',
    },
    flexDirection: 'column',
    gap: {
      xs: '16px',
      md: '20px',
      lg: '24px',
    },
    borderRadius: '16px',
    padding: '1.5rem',
    boxShadow: 3,
  },
  restCardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '1rem',
    width: '100%',
    rowGap: '1rem',
  },
  sectionWrapper: {},
  restCardRow: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
  },
  mobileStatsCard: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
